module.exports = __webpack_public_path__ + "img/diashow (11).794452a.jpg";